import React, { useState } from 'react'
import { CCard, CCardBody, CCardHeader, CFormInput, CCol, CRow, CButton, CAccordion, CAccordionItem, CAccordionHeader, CAccordionBody, CFormLabel } from '@coreui/react'
import { DataGrid } from '@mui/x-data-grid'
import { Link, useLoaderData, useLocation, useNavigate } from 'react-router-dom'
import AxiosInstance from 'src/components/Axios'
import { cilPen, cilPlus, cilTrash } from '@coreui/icons'
import CIcon from '@coreui/icons-react'
import { useEffect } from 'react'
import { confirmAlert } from 'react-confirm-alert'
import AsyncSelect from 'react-select/async'
// import { Select } from '@mui/material'
import Select from 'react-select';
import { useConvertToLocalTime } from 'src/components/store/useConvertToLocalTime'
import dayjs from 'dayjs';



const page = 1
const urlApi = '/safety_measures_lists'
const urlRouter = '/safety_measures_lists'

// хто увійшов
const role = localStorage.getItem('user_role')
// console.log(role)

// дані користувача
const userData = JSON.parse(localStorage.getItem('user_data'))
const tokenStr = localStorage.getItem('user')
const header = { headers: { Authorization: `Bearer ${tokenStr}`, accept: 'application/json' } }
const utcNow = dayjs().toISOString()
// console.log('userData', userData)
// перше завантаження
export async function LoaderSafetyMeasuresLists({ params }) {
   let query = `page=${page}`
   const request = `account.user.id=${userData.id}`

   // запит тільки даних користувача
   if (role === 'ROLE_ADMIN') {
      // console.log('запит адмін')
      let res = await AxiosInstance.get(`${urlApi}?${query}`).then((response) => {
         return response
      })
      return res
   } else {
      // console.log('запит партнера')
      let res = await AxiosInstance.get(`${urlApi}?${query}&${request}`).then((response) => {
         return response
      })
      return res
   }
   // if (Array.isArray(res.data)) {
   //   res.data.sort((a, b) => dayjs(b.dateModified).valueOf() - dayjs(a.dateModified).valueOf());
   // }


}

// головний контент
const WorkPlanSafetyMeasures = () => {
   const { data } = useLoaderData() || { data: {} };
   console.log('data Jobs', data)
   const { state } = useLocation();
   // console.log('state1', state);

   const [rows, setRows] = useState(false)
   const [rowCountState, setRowCountState] = useState(0)
   // для пошуку
   const [nameFilterSearch, setNameFilterSearch] = useState('')
   const [descriptionFilterSearch, setDescriptionFilterSearch] = useState('')
   const [partnerFilterSearch, setPartnerFilterSearch] = useState('')
   const [statusFilterSearch, setStatusFilterSearch] = useState('')
   const [factoryFilterSearch, setFactoryFilterSearch] = useState('')
   const [dateEnteredAfterFilterSearch, setDateEnteredAfterFilterSearch] = useState('')
   const [dateEnteredBeforeFilterSearch, setDateEnteredBeforeFilterSearch] = useState('')
   const [showLoader, setShowLoader] = useState(false)

   //логічний стан скидання фільтра
   const [resetFiltersFlag, setResetFiltersFlag] = useState(false);



   // Заблокувати кнопку фільрації якщо не введені символи для пошуку
   const [disabled, setDisabled] = useState(true)
   const navigate = useNavigate();

   // Список можливих статусів
   const optionsStatus = [
      { value: 'new', label: 'Нова' },
      { value: 'send-to-verify', label: 'Відправлено на перевірку' },
      { value: 'rejected', label: 'Відхилено' },
      { value: 'verified', label: 'Підтверджено' },
   ];

   // Якщо лінк відбувся з головної сторінки по "not_checked", то віддразу відфільтрувати
   // useEffect(() => {
   //    if (state?.status === "not_checked") {
   //       // Задати значення "Статус" в фільтрі для коректного відображення активного фільтра
   //       setStatusFilterSearch({ value: 'not_checked', label: 'Не перевірено' });
   //       AxiosInstance.get(`${urlApi}?status=${state.status}`).then((response) => {
   //          //Сортування по полю dateModified
   //          const sorted = [...response.data['hydra:member']].sort((a, b) => {
   //             const aDate = a.dateModified ? dayjs(a.dateModified).valueOf() : 0
   //             const bDate = b.dateModified ? dayjs(b.dateModified).valueOf() : 0
   //             return bDate - aDate
   //          })

   //          setRows(sorted)
   //          setRowCountState(response.data['hydra:totalItems'])
   //          //Сортування по полю dateModified
   //          // setRows(response.data['hydra:member']);
   //          // setRowCountState(response.data['hydra:totalItems']);
   //       });
   //    }
   // }, [state]);


   //Сортування по dateModified при першому заповненні
   if (!rows && data?.['hydra:member']) {
      const sorted = [...data?.['hydra:member']]?.sort((a, b) => {
         const aDate = a.dateModified ? dayjs(a.dateModified).valueOf() : 0
         const bDate = b.dateModified ? dayjs(b.dateModified).valueOf() : 0
         return bDate - aDate
      })

      setRows(sorted)
      setRowCountState(data['hydra:totalItems'])
   }


   // Фільтр
   const getRowsTable = (p = 1) => {
      setShowLoader(true)
      let request = ``
      // перевірка чи є щось в імені
      if (nameFilterSearch !== '') {
         request += `&name=${nameFilterSearch}`
         if (role === 'ROLE_ADMIN') request += `&name=${nameFilterSearch}`
         if (role === 'ROLE_PARTNER') request += `&accountWorkers.account.${nameFilterSearch}`
      }
      if (descriptionFilterSearch !== '') {
         // request += `&description=${descriptionFilterSearch}`
         if (role === 'ROLE_ADMIN') request += `&description=${descriptionFilterSearch}`
         // if (role === 'ROLE_PARTNER') request += `&accountWorkers.account.${nameFilterSearch}`
      }

      // якщо вибрананий контрагент

      if (partnerFilterSearch !== '') request += `&account.name=${partnerFilterSearch.label}`
      if (statusFilterSearch !== '') request += `&status=${statusFilterSearch.value}`
      if (factoryFilterSearch !== '') request += `&factory.id=${factoryFilterSearch.value}`
      // if (dateEnteredAfterFilterSearch !== '') request += `&dateEntered[after]=${dateEnteredAfterFilterSearch}` // не включно
      if (dateEnteredAfterFilterSearch !== '') request += `&dateEntered[strictly_after]=${dateEnteredAfterFilterSearch}` // включно
      // if (dateEnteredBeforeFilterSearch !== '') request += `&dateEntered[before]=${dateEnteredBeforeFilterSearch}` // не включно
      if (dateEnteredBeforeFilterSearch !== '') request += `&dateEntered[strictly_before]=${dateEnteredBeforeFilterSearch}` // не включно (хіба додатково ввести час)

      // відображаємо тільки з даних користувача
      // if (role === 'ROLE_PARTNER') request += `&user.id=${userData.id}`
      if (role === 'ROLE_PARTNER') request += `&account.user.id=${userData.id}`

      // запит після пошуку
      AxiosInstance.get(`${urlApi}?page=${p}${request}`).then((response) => {
         setRows(response.data['hydra:member'])
         setRowCountState(response.data['hydra:totalItems'])
         setShowLoader(false)
      })
   }

   // зміна сторінки
   const handlePageChange = (page) => {
      getRowsTable(page + 1)
   }

   // Заблокувати кнопку фільтрації, якщо не введені символи для пошуку
   const disabledButton = () => {
      setDisabled(
         typeof partnerFilterSearch === 'string' &&
         partnerFilterSearch.trim() === '' &&
         nameFilterSearch.trim() === '' &&
         descriptionFilterSearch.trim() === '' &&
         statusFilterSearch === '' &&
         factoryFilterSearch === '' &&
         dateEnteredAfterFilterSearch === '' &&
         dateEnteredBeforeFilterSearch === ''
      );
   };

   // Розблокувати кнопку, якщо хоча б одне поле містить значення
   useEffect(() => {
      disabledButton()
   }, [nameFilterSearch, descriptionFilterSearch, partnerFilterSearch, statusFilterSearch, factoryFilterSearch, dateEnteredAfterFilterSearch, dateEnteredBeforeFilterSearch])

   // зміна стейту пошуку "Назва"
   const handleNameFilterChange = (e) => {
      setNameFilterSearch(e.target.value)
      disabledButton(e)
   }

   //зміна стейту пошуку "Опис"
   const handleDescriptionFilterChange = (e) => {
      setDescriptionFilterSearch(e.target.value)
      disabledButton(e)
   }

   // Фільтрування
   const handleFilterSearch = () => {
      getRowsTable()
   }

   // Скинути фільтр і показати весь список
   const handleFilterReset = () => {
      setNameFilterSearch('')
      setDescriptionFilterSearch('')
      setPartnerFilterSearch('')
      setStatusFilterSearch('')
      setFactoryFilterSearch('')
      setDateEnteredAfterFilterSearch('')
      setDateEnteredBeforeFilterSearch('')
      setDisabled(true)

      setResetFiltersFlag(true);
      // getRowsTable()
   }

   //чистий запит після скидання фільтра
   useEffect(() => {
      if (resetFiltersFlag) {
         getRowsTable();
         setResetFiltersFlag(false);
      }
   }, [resetFiltersFlag]);


   async function deleted(row) {
      try {
         await confirmAlert({
            title: 'Ви впевнені що хочите видалити цей пункт ?',
            message: 'Are you sure to do this.',
            buttons: [
               {
                  label: 'Так',
                  onClick: async () => {
                     const response = await AxiosInstance.delete(`${urlApi}/${row.id}`)

                     console.log('Пункт успішно видалено.', response)

                     getRowsTable()
                  },
               },
               {
                  label: 'Ні',
                  onClick: () => {
                     return
                  },
               },
            ],
         })
      } catch (error) {
         console.error('Помилка видалення:', error)
      }
   }

   // Дані, які навнюються в таблицю
   const columns = [
      { field: 'id', headerName: 'ID', width: 50 },
      // { field: 'code1c', headerName: 'code1c', width: 95 },
      // {
      //    field: 'dateEntered',
      //    headerName: 'Дата створення',
      //    width: 150,
      //    renderCell: (params) => {
      //       return (
      //          <span>
      //             {params.row?.dateEntered ? useConvertToLocalTime(params.row.dateEntered) : "❌"}
      //          </span>
      //       )
      //    },
      // },
      // {
      //    field: 'dateModified',
      //    headerName: 'Дата зміни',
      //    width: 150,
      //    renderCell: (params) => {
      //       return (
      //          <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
      //             {params.row?.dateModified ? dayjs(params.row.dateModified).local().format('YYYY-MM-DD HH:mm:ss') : "-"}
      //          </div>
      //       )
      //    },
      // },
      {
         field: 'name',
         headerName: 'Назва',
         width: 400,
         renderCell: (params) => {
            return (
               <Link
                  to={`${urlRouter}/update/${params.row.id}`}
                  style={{ textDecoration: 'none' }}
               >
                  {params.row.name}
               </Link>
            )
         },
      },

      { field: 'description', headerName: 'Опис', width: 400 },
      // { field: 'status', headerName: 'Статус', width: 110 },

      // {
      //    field: 'params.row.account.name',
      //    headerName: 'Контрагент',
      //    width: 380,
      //    renderCell: (params) => {
      //       return (
      //          params.row.account.name
      //       )
      //    },
      // },
      // {
      //    field: 'factory',
      //    headerName: 'Підрозділ',
      //    width: 185,
      //    renderCell: (params) => {
      //       return (
      //          <span>
      //             {params.row.factory?.name ? params.row.factory.name : ""}
      //          </span>
      //       )
      //    },
      // },

      {
         field: 'action',
         headerName: 'Action',
         width: 70,
         sortable: false,
         renderCell: (params) => {
            return (
               <Link to={`${urlRouter}/update/${params.row.id}`}>
                  <CButton color="dark" variant="outline">
                     <CIcon icon={cilPen} customClassName="nav-icon" height={20} />
                  </CButton>
               </Link>
            )
         },
      },
      // {
      //    field: 'delete',
      //    headerName: 'Видалити',
      //    width: 80,
      //    sortable: false,
      //    renderCell: (params) => {
      //       return (
      //          <CButton
      //             color="danger"
      //             variant="outline"
      //             onClick={() => {
      //                deleted(params.row)
      //             }}
      //          >
      //             <CIcon icon={cilTrash} customClassName="nav-icon" height={20} />
      //          </CButton>
      //       )
      //    },
      // },
   ]

   // Натиснення кнопки: "Enter" - виконати пошук; "Escape" - скинути пошук
   const keyDown = (event) => {
      // Виконати пошук
      if (event.key === 'Enter' && !disabled) {
         event.preventDefault()
         handleFilterSearch(event)
      }
      // Скинути пошук
      if (event.key === 'Escape') {
         event.preventDefault()
         handleFilterReset(event)
      }
   }



   // логіка запиту у фільтрації 

   const loadOptions = async (inputValue) => {
      if (role === 'ROLE_ADMIN') {
         return await AxiosInstance.get(`/accounts?name=${inputValue}`, header).then((response) => {
            return response.data.map((result) => ({
               label: result.name,
               value: result.id,
            }));
         });
      } else {
         if (userData.id) {
            return await AxiosInstance.get(`/accounts?user.id=${userData.id}&name=${inputValue}`, header).then((response) => {
               return response.data.map((result) => ({
                  label: result.name,
                  value: result.id,
               }));
            });
         }
      }
   }



   // Завантажити список підрозділів
   const loadOptionsFactory = async (inputValue) => {
      return await AxiosInstance.get(`/factories`, header).then((response) => {
         // console.log('response get /factories', response)
         return response.data.map((result) => ({
            label: result.name,
            value: result.id,
         }))
      })
   }

   // при зміні опції
   const handleChangePartner = (select) => {
      setPartnerFilterSearch(select)
   }
   // const [selectedOption, setSelectedOption] = useState(null);

   const handleChangeStatus = (select) => {
      setStatusFilterSearch(select)
   }

   // при зміні опції
   const handleChangeFactory = (select) => {
      setFactoryFilterSearch(select)
   }

   // const handleChange = (selectedOption) => {
   //   setSelectedOption(selectedOption);
   // };

   console.log('rows', rows)

   return (
      <CRow>
         <CCol xs={12}>
            <CCard className="mb-4">

               <CAccordion flush>
                  <CAccordionItem>
                     <CAccordionHeader onClick={loadOptions}>
                        <strong>Фільтр</strong>
                     </CAccordionHeader>
                     <CAccordionBody>
                        <CRow className="my-3 mx-2">
                           <CCol md={9} className="me-auto">
                              <CRow>
                                 <CCol
                                    // md={3}
                                    md={5}
                                    className="filter-field">
                                    <CFormInput
                                       placeholder="Назва"
                                       id="nameFilterSearch"
                                       aria-label="Пошук"
                                       className="me-2"
                                       onChange={handleNameFilterChange}
                                       value={nameFilterSearch}
                                       onKeyDown={keyDown}
                                       autoComplete="off"
                                    />
                                 </CCol>
                                 {/*  опис */}
                                 <CCol
                                    md={5}
                                    className="filter-field">
                                    <CFormInput
                                       placeholder="Опис"
                                       id="descriptionFilterSearch"
                                       aria-label="Пошук"
                                       className="me-2"
                                       onChange={handleDescriptionFilterChange}
                                       value={descriptionFilterSearch}
                                       onKeyDown={keyDown}
                                       autoComplete="off"
                                    />
                                 </CCol>

                                 {/* <CCol md={3} className="filter-field">

                                    <AsyncSelect
                                       cacheOptions
                                       loadOptions={loadOptions}
                                       defaultOptions
                                       value={partnerFilterSearch}
                                       onChange={handleChangePartner}
                                       className="flex-grow-1"
                                       placeholder="Контрагент"
                                    />
                                 </CCol> */}

                                 {/* <CCol md={3} className="filter-field">
                                    <Select
                                       options={optionsStatus}
                                       value={statusFilterSearch}
                                       onChange={handleChangeStatus}
                                       className="flex-grow-1"
                                       placeholder="Статус"
                                    />
                                 </CCol> */}

                                 {/* <CCol md={3} className="filter-field">
                                    <AsyncSelect
                                       cacheOptions
                                       loadOptions={loadOptionsFactory}
                                       defaultOptions
                                       value={factoryFilterSearch}
                                       onChange={handleChangeFactory}
                                       className="flex-grow-1"
                                       placeholder="Підрозділ"
                                    />
                                 </CCol> */}

                                 <CCol md={4} className="filter-field">

                                    <CFormLabel className="mt-3" htmlFor="exampleFormControlInput2">Дата створення (від, включно)</CFormLabel>
                                    <CFormInput
                                       type="date"
                                       id="exampleFormControlInput2"
                                       defaultValue="Дата створення (від)"
                                       value={dateEnteredAfterFilterSearch}
                                       onChange={(e) => setDateEnteredAfterFilterSearch(e.target.value)}
                                       autoComplete="off"
                                    />

                                 </CCol>

                                 <CCol md={4} className="filter-field">

                                    <CFormLabel className="mt-3" htmlFor="exampleFormControlInput2">Дата створення (до, не включно)</CFormLabel>
                                    <CFormInput
                                       type="date"
                                       id="exampleFormControlInput2"
                                       defaultValue="Дата створення (до)"
                                       value={dateEnteredBeforeFilterSearch}
                                       onChange={(e) => setDateEnteredBeforeFilterSearch(e.target.value)}
                                       autoComplete="off"
                                    />

                                 </CCol>
                              </CRow>
                           </CCol>

                           <CCol md={3} style={{ textAlign: 'end' }}>
                              <CButton className="me-2" type="submit" color="secondary" onClick={handleFilterSearch} disabled={disabled}>Пошук</CButton>
                              <CButton type="submit" color="secondary" onClick={handleFilterReset}>X</CButton>
                           </CCol>
                        </CRow>
                     </CAccordionBody>
                  </CAccordionItem>
               </CAccordion>

               <CCardHeader>
                  <strong>Заходи з ОП</strong> <small></small>
               </CCardHeader>
               <CCardBody>
                  <p className="text-medium-emphasis small">
                     <Link to={`${urlRouter}/create`}>
                        <CButton color="secondary">
                           <CIcon icon={cilPlus} customClassName="nav-icon" height={15} />
                           Створити
                        </CButton>
                     </Link>
                     {/* <CButton color="primary" onClick={() => navigate('/work_plan')}>
                        Перейти на WorkPlan
                     </CButton> */}
                  </p>
                  <div style={{ height: 400, width: '100%', }}>
                     <DataGrid
                        rows={rows}
                        columns={columns}
                        pageSize={30}
                        rowsPerPageOptions={[30]}
                        pagination
                        rowCount={rowCountState}
                        paginationMode="server"
                        onPageChange={handlePageChange}
                        loading={showLoader}
                     />
                  </div>
               </CCardBody>
            </CCard>
         </CCol >
      </CRow >
   )
}

export default WorkPlanSafetyMeasures
